import './style/quasar.styl';
import 'quasar/dist/quasar.ie.polyfills';
import '@quasar/extras/roboto-font/roboto-font.css';
import '@quasar/extras/material-icons/material-icons.css';
import './style/site.scss';

import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

import {Quasar} from 'quasar';

import featuresSection from './components/store/features.vue';
import offersSection from './components/store/offers.vue';
import jumboSection from './components/store/jumbo.vue';

import vueScrollTo from 'vue-scrollto';

Vue.config.productionTip = false;
Vue.component('features', featuresSection);
Vue.component('jumbo', jumboSection);
Vue.component('offers', offersSection);

Vue.use(Quasar);
Vue.use(vueScrollTo);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
